import React, { useRef } from "react";
import { useSelector } from "react-redux";

import Button from "src/components/button";
import CollectionWidgetManager from "src/utils/collections.widget.service";

import { useComposeAdoption } from "src/redux/actions/adoption/compose";

import _ from "lodash";
import cx from "classnames";
import styles from "./widgets.module.scss";

const assetViewImage = '/images/compose/assetView.svg'
const viewCollectionButton = '/images/compose/viewCollectionButton.svg'
const linkImage = '/images/compose/linkImage.svg'
const signature = '/images/compose/signature.svg'

const widgetsData = [
  {
    title: "Asset Table",
    description: "The content assets that you add while sharing will be displayed here.",
    image: assetViewImage,
    imageClass: styles.assetImage,
    id: "assets.grid",
  },
  {
    title: "CTA button",
    description: "The Content that you add while insert as a CTA.",
    image: viewCollectionButton,
    imageClass: styles.collectionImage,
    id: "collection.cta"
  },
  {
    title: "Link as a text",
    description: "Insert a link to your content as a text",
    image: linkImage,
    imageClass: styles.linkImage,
    id: "collection.link"
  },
  {
    title: "Signature",
    description: "Insert your profile signature",
    image: signature,
    imageClass: styles.signatureImage,
    id: "signature.description"
  }
]

interface WidgetsProps {
  isDealRoom: boolean;
  width: number;
  onSelection: (widgetId: string) => void;
  onClose: () => void;
}

const Widgets: React.FC<WidgetsProps> = ({ isDealRoom, width, onSelection, onClose }) => {
  const user = useSelector((state: any) =>
    _.get(state, "users.me", null),
  );
  return (
    <section className={styles.widgetsContainer}>
      <div className={styles.headerContainer}>
        <h3 className={styles.heading}>choose your widget</h3>
        <i className="paperflite-close" onClick={onClose}></i>
      </div>
      <div className={styles.bodyContainer}>
        {widgetsData.map((widget) => {
            if (widget.id === "signature.description" && !user?.emailSignature) {
              return null; 
            }

            if (["collection.cta", "collection.link"].includes(widget.id) && isDealRoom) {
              widget.id = widget.id.replace("collection", "dealRoom");
            }

          return (
            <Widget
              key={widget.id}
              className={widget.imageClass}
              title={widget.title}
              description={widget.description}
              widgetId={widget.id}
              image = {widget.image}
              onSelection={onSelection}
            />
          );
        })}
      </div>
    </section>
  );
};
export default Widgets;

interface WidgetProps {
  title: string;
  description: string;
  image?: string;
  className: string;
  text?: string;
  widgetId: string;
  onSelection: (widgetId: string) => void;
}

const Widget: React.FC<WidgetProps> = ({ className, title, description, image, widgetId, onSelection }) => {
  const {trackWidgetInserted} = useComposeAdoption();


  const handleInsertWidgetClick = (widgetId: string) => {
    let widgetType = "";
    switch (widgetId) {
      case "assets.grid":
        widgetType = "Asset Table";
        break;
      case "collection.cta":
        widgetType = "View Collection Button";
        break;
      case "collection.link":
        widgetType = "Link";
        break;
      case "signature.description":
        widgetType = "Signature";
        break;
    }
    trackWidgetInserted({widgetType})
    onSelection(widgetId);
  };

  return (
    <div className={styles.widgetContainer}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      {image && (
        <img src={image} alt={title} className={cx(styles.image, className)} />
      )}
      <Button
        className={styles.buttonContainer}
        onClick={() => handleInsertWidgetClick(widgetId)}
      >
        <i className="paperflite-add"></i>
        <div className={styles.text}>Add</div>
      </Button>
    </div>
  );
}
